import { Component, OnInit } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { DefaultDegressivitySlice } from '@classes/default-degressivity-slice';
import { DefaultPriceService } from 'app/core/services/default-price.service';
import { IndexService } from 'app/core/services/index.service';
import { UiService } from 'app/core/services/ui.service';

@Component({
  selector: 'app-price-degressivity-slice',
  templateUrl: './price-degressivity-slice.component.html',
  styleUrls: ['./price-degressivity-slice.component.scss']
})
export class PriceDegressivitySliceComponent implements OnInit {

  displayIndexesPrice = false;
  dataSource = new MatTableDataSource<DefaultDegressivitySlice>();
  selectedRowID: string;
  displayedColumns: string[] = [
    // 'number',
    'name',
    'price',
    // 'indexPrice',
    // 'percentage'
  ];
  constructor(
    private uiService: UiService,
    private indexService: IndexService,
    private defaultPriceService: DefaultPriceService
  ) { }

  ngOnInit() {
    this.getDefaultDegressivitySlice();
  }

  selectItemClick(item: DefaultDegressivitySlice) {
    this.selectedRowID = item.id || '';
  }
  getDefaultDegressivitySlice() {
    this.uiService.addRouteLoading();
    this.defaultPriceService.getDefaultDegressivitySlice().subscribe(data => {
      let counter = 1;
      const maxPercentage =Math.max(...data.map(o=>(o.percentage || 0)));
      data.forEach((fe, index) => {
        fe.number = counter;
        fe.indexPrice = (fe.price || 1) * (this.indexService.currentCoef?.value || 1);
        if (!fe.isLastSlice) {
          fe.name = `Jusqu'à ${fe.percentage} % du tonnage minimm annuel`;
        } else {
          fe.name = `Plus de ${maxPercentage} % du tonnage minimm annuel`;
        }
        // if (counter < data.length) {
        //   fe.name = `Jusqu'à ${fe.percentage} % du tonnage minimm annuel`;
        // } else {
        //   fe.name = `Plus de ${data[index-1].percentage} % du tonnage minimm annuel`;  
        // }
        counter++;
      });
      this.dataSource.data = data;
      this.uiService.removeRouteLoading();
    }, error => {
      console.error(error);
      this.uiService.removeRouteLoading();
    })
  }

}
